import { HorizontalStack, Text, VerticalStack } from "@shopify/polaris";
import { Subheading } from "../..";
import { ToggleSwitch } from "@vendor-app/app/AdminRoute/AdminLoyaltyRoute/components/ToggleSwitch";

interface InstantDigitalItemFulfillmentEnabledSettingProps {
  instantDigitalItemFulfillmentEnabled: boolean;
  setInstantDigitalItemFulfillmentEnabled: React.Dispatch<React.SetStateAction<boolean | null | undefined>>;
}

export function InstantDigitalItemFulfillmentEnabledSetting({
  instantDigitalItemFulfillmentEnabled,
  setInstantDigitalItemFulfillmentEnabled,
}: InstantDigitalItemFulfillmentEnabledSettingProps) {
  return (
    <div className="Polaris-LegacyCard__Section" data-testid="instant-digital-item-fulfillment-setting">
      <VerticalStack gap="1">
        <HorizontalStack gap="2" blockAlign="center">
          <Text as="h3" variant="headingSm">
            Instant digital item fulfillment
          </Text>
          <ToggleSwitch
            defaultToggled={instantDigitalItemFulfillmentEnabled}
            onHandleChangeCB={v => {
              setInstantDigitalItemFulfillmentEnabled(v);
            }}
          />
        </HorizontalStack>
        <Subheading className="card-subheading">
          {
            "When enabled, digital products that don't require shipping are fulfilled immediately with a separate order instead of waiting for the next billing cycle. This applies to: one-time add-ons, loyalty rewards redeemed to a subscription, and loyalty rewards redeemed as one-time purchases."
          }
        </Subheading>
      </VerticalStack>
    </div>
  );
}
